import React from 'react'
import { Dashboard } from './Pages/Frontend/Interface/Index'

export const ConditionalRouting = () => {
  return <Dashboard />
}
